exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".remove-from-cart{cursor:pointer;text-align:center}.remove-from-cart img{width:12px}", ""]);

// exports
